import Element, { ElementType, SpecyficType } from './element';
import { HelpPoint, HelpPointType } from './helpPoint';

class HandlesManager {

    private elements!: Element[];

    public initialize(elements: Element[]) {
        this.elements = elements;
    }

    public getHelpPoints(element: Element): HelpPoint[] {
        const body = this.elements.find((x) => x.type === ElementType.BODY)!;
        const helpPoints = element.helpPoints;
        const handle = element.bindings.find((x) => x.type === ElementType.HANDLE);
        if (!helpPoints.length) { return []; }
        if (!helpPoints[0].isVertical) { return helpPoints; }
        if (handle) {
            return element.center.x < handle.center.x ?
                this.left(helpPoints) :
                this.right(helpPoints);
        }
        if (element.shape.x < element.slot.shape.x) {
            return element.position.x > element.slot.position.x ?
                this.left(helpPoints) :
                this.right(helpPoints);
        }
        const hinge = element.bindings.find(x => x.type === ElementType.HINGE);
        if (hinge) {
            return hinge.model.includes('_L') ?
                this.right(helpPoints) :
                this.left(helpPoints);
        }
        if (element.position.x > body.shape.x / 2) {
            return this.left(helpPoints);
        }
        return this.right(helpPoints);
    }

    public getOppositeHelpPoint(front: Element): HelpPoint {
        const helpPoints = front.helpPoints;
        const handle = front.bindings.find((x) =>
            x.type === ElementType.HANDLE);
        if (handle) {
            if (handle.center.x < front.center.x) {
                return this.left(helpPoints)[0];
            }
            return this.right(helpPoints)[0];
        }
        const hinge = front.bindings.find((x) =>
            x.type === ElementType.HINGE);
        if (hinge) {
            if (hinge.model.includes('_L')) {
                return this.left(helpPoints)[0];
            }
            return this.right(helpPoints)[0];
        }
        return this.right(helpPoints)[0];
    }

    public canChangeHandlePosition(front: Element): boolean {
        const isDrawerFront = front.bindings
            .some((x) => x.specyficType === SpecyficType.DRAWER);
        if (isDrawerFront) { return false; }

        if (front.slot.shape.x > front.shape.x) { return false; }

        // const handle = front.bindings.find((x) =>
        //     x.type === ElementType.HANDLE);
        // if (!handle) { return false; }

        return true;
    }

    private left(helpPoints: HelpPoint[]): HelpPoint[] {
        return [helpPoints.find((x) => x.type === HelpPointType.LEFT)!];
    }

    private right(helpPoints: HelpPoint[]): HelpPoint[] {
        return [helpPoints.find((x) => x.type === HelpPointType.RIGHT)!];
    }
}

export const handlesManager = new HandlesManager();
